export default __webpack_public_path__ + "static/media/reset-icon.df89fb62.svg";